<template>
  <div class="bg-color-tab">
    <div class="p-5">
      <b-col class="col-lg-12 text-center">
        <p class="h1 m-5 font-weight-bold">
          <slot name="p-1"></slot>
        </p>

        <b-container>
          <b-row class="mb-5">
            <b-col class="tabs effect-1 text-center">
              <!-- tab-title -->
              <input type="radio" id="tab-1" name="tab-effect-1"/>
              <span class="h5 font-weight-bolder "
              ><slot name="pl-1"></slot>
              </span>

              <input
                  type="radio"
                  id="tab-2"
                  name="tab-effect-1"
                  checked="checked"
              />
              <span class="h5 font-weight-bolder"
              ></b-icon>
                <slot name="pr-1"></slot>
              </span>

              <!-- tab-content -->
              <b-row class="col-auto tab-content m-auto">
                <section id="tab-item-1">
                  <slot name="p-3"></slot>
                </section>

                <section id="tab-item-2">
                  <slot name="p-2"></slot>
                </section>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </div>
  </div>
</template>

<script>
export default {
  name: "S3",
};
</script>

<style scoped>
/*
 * Title: Pure CSS3 Tabs
 * Author: Clear
 * Version: 1.0.1
 * Create: 2015-05-31
 * Update: 2015-06-05
 */
/* CSS Reset */

#tab-item-2 {
  animation: 0.4s ease-out 0s 1 slideInFromLeft;
}

#tab-item-1 {
  animation: 0.4s ease-out 0s 1 slideInFromLeft;
}

@keyframes slideInFromLeft {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(0);
  }
}

a:hover,
a:focus {
  text-decoration: none;
  outline: none;
}

.btn-white {
  background-color: var(--white);
  width: 150px;
  min-width: 100px;
  height: 50px;
  position: inherit;
  margin: 2%;
}

/* Tabs Start */

.tabs {
  border-radius: 50px;

  margin-top: 10%;
  width: 85%;
  height: auto;
  background-color: rgba(var(--teal) 0.36);
  box-sizing: border-box;
}

.tabs > input,
.tabs > span {
  width: 30%;
  height: 70px;

  line-height: 60px;
  position: absolute;
  top: -90px;
  text-align: center;
  color: var(--gray);
}

.tabs > input {
  cursor: pointer;
  filter: alpha(opacity=0);
  opacity: 0;
  position: absolute;
  z-index: 99;
}

.tabs > span {
  /*background-color:#2637fb;*/
  background-color: rgba(var(--secondary-rgba), 0.76);
  box-shadow: 0 0 15px gray;

  /*background: rgba(255,25,255,.1);*/
  text-align: center;
  overflow: hidden;
}

.tabs > span i,
.tabs > span {
  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
  -o-transition: all 0.5s;
  transition: all 0.5s;
  background-color: transparent;
  box-shadow: 0 0 16px var(--gray);
}

.tabs > input:checked + span {
  background-color: var(--primary-rgba);
}

.tabs > input:checked + span,
.tabs > input:hover + span {
  /*color: #3498DB;*/
  color: var(--white);

  background-color: var(--primary);
}

#tab-1,
#tab-1 + span {
  left: 11%;
  border-radius: 20px;
}

#tab-2,
#tab-2 + span {
  left: 60%;
  border-radius: 20px;
}

#tab-3,
#tab-3 + span {
  left: 70%;
  border-radius: 20px;
}

#tab-4,
#tab-4 + span {
  left: 100%;
}

#tab-5,
#tab-5 + span {
  left: 80%;
}

.tab-content {
  padding: 20px 20px 20px;
  width: 100%;
  height: auto;

  background-color: var(--light-info) !important;
  border-radius: 30px;
}

.tab-content section {
  width: 100%;
  display: none;
}

.tab-content section h1 {
  margin-top: 15px;
  font-size: 100px;
  font-weight: 100;
  text-align: center;
}

#tab-1:checked ~ .tab-content #tab-item-1 {
  display: block;
  text-align: center;
}

#tab-2:checked ~ .tab-content #tab-item-2 {
  display: block;
}

#tab-3:checked ~ .tab-content #tab-item-3 {
  display: block;
}

#tab-4:checked ~ .tab-content #tab-item-4 {
  display: block;
}

#tab-5:checked ~ .tab-content #tab-item-5 {
  display: block;
}

/* effect-1 */

.effect-1 > input:checked + span {
  background-color: rgba(10, 6, 15, 0.36);
}

/* effect-3 */

#tab-1:checked ~ .line {
  left: 0;
}

#tab-2:checked ~ .line {
  left: 20%;
}

#tab-3:checked ~ .line {
  left: 40%;
}

#tab-4:checked ~ .line {
  left: 60%;
}

#tab-5:checked ~ .line {
  left: 80%;
}

/* effect-5 */

.effect-5 > input:checked + span i,
.effect-5 > input:hover + span i {
  font-size: 25px;
}

.bg-color-tab {
  background-color: rgba(var(--primary-rgba), 0.76);
}
</style>